import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../lib/utils';

/**
 * Status pill. `variant` is semantic, not decorative -- it encodes event
 * status, correction state and role, so the colour has to mean something.
 */
const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-sm px-2 py-0.5 font-sans text-xs font-semibold whitespace-nowrap',
  {
    variants: {
      variant: {
        neutral: 'bg-surface-sunk text-ink-soft border border-line',
        brand: 'bg-brand/10 text-brand-deep border border-brand/20',
        success: 'bg-success-bg text-success border border-success/25',
        warning: 'bg-warning-bg text-warning border border-warning/25',
        danger: 'bg-danger-bg text-danger border border-danger/25',
        info: 'bg-info-bg text-info border border-info/25',
        solid: 'bg-brand text-white',
      },
    },
    defaultVariants: { variant: 'neutral' },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

const Badge = ({ className, variant, ...props }: BadgeProps) => (
  <span className={cn(badgeVariants({ variant }), className)} {...props} />
);

export { Badge, badgeVariants };
